import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { Container } from '../../styles/defaults'
import { Header, Description } from './styles'

import hero from '../../assets/hero/bestellijst/bestellijst.jpg'

class Confirmation extends Component {
  render() {

    const { content } = this.props
    return (
      <Fragment>
        <Hero setsize="small" small={hero} medium={hero} large={hero} retina={hero} title={content.header} />
        <Breadcrumb title="Bevestiging" />
        <Container small mt mb>
          <Header>{content.title}</Header>
          <Description dangerouslySetInnerHTML={{__html: content.firstLine}} />
          <Description dangerouslySetInnerHTML={{__html: content.secondLine}} />
          <Description>
            <Link to="/">Terug naar dashboard.</Link>
          </Description>
        </Container>
      </Fragment>
    )
  }
}

export default withHeaderFooter(Confirmation)



// WEBPACK FOOTER //
// ./src/views/Confirmation/index.js